import axios from 'axios'
import {Toast} from 'wot-design'
import {find} from "@/utils/status";

axios.defaults.timeout = 30000;

// 创建一个axios实例

axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
//http response 拦截器
axios.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        if (!error.response) {
            return error
        }
        const status = error.response.status;
        Toast.error({
            msg: find(status),
        })
        return Promise.reject(error.response);
    }
);
// 将写好的axios实例暴露出去
export default axios
